export default __webpack_public_path__ + "static/media/taskade-circle-icon.e388ffc9.png";